module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fade page-sidebar-fixed page-header-fixed in",
    attrs: {
      "id": "page-container"
    }
  }, [(_vm.$store.state.auth.loggedIn) ? _c('app-header') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.loggedIn) ? _c('app-sidebar') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.loggedIn) ? _c('div', {
    staticClass: "sidebar-bg"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "id": "content"
    }
  }, [(_vm.$store.state.error.visible) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_vm._v("\n      " + _vm._s(_vm.$store.state.error.message) + "\n      "), _c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    },
    on: {
      "click": function($event) {
        return _vm.$store.commit('error_dismiss')
      }
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), (_vm.$store.state.auth.loggedIn) ? _c('app-footer') : _vm._e(), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-icon btn-circle btn-success btn-scroll-to-top fade",
    attrs: {
      "href": "javascript:;",
      "data-click": "scroll-top"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-517b0bbf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1338
// module chunks = 0